import styled from "styled-components";
import * as colors from "../../settings/colors";

const ErrorMessage = styled.p`
  font-size: 13px;
  color: ${colors.RED};
  margin: 4px 0 0;
`;

export default ErrorMessage;



// WEBPACK FOOTER //
// ./src/components/forms/ErrorMessage.js